import { createSlice } from '@reduxjs/toolkit'

import { fetchContent, fetchPartPaymentWidget } from '../requests/thunks'

interface InitState {
  applicationMode: string
  channelId: string
  marketCode: 'SE-SKBV' | 'SE-BYME' | 'NO-GF' | 'FI-NR' | 'NO-BYME' | ''
  languageCode: 'sv_SE' | 'nb_NO' | 'sv_FI' | 'fi_FI' | ''
  langMarketCode: 'sv-SE-SKBV' | 'sv-SE-BYME' | 'nb-NO-GF' | 'sv-FI-NR' | 'fi-FI-NR' | 'nb-NO-BYME' | '' | any
  assetBaseUrl: string
  productConfiguratorAdaptersScriptUrl: string
  productConfiguratorControllerScriptUrl: string
  isStoreLoggedIn: boolean
  content: Record<PropertyKey, any>
  partPaymentWidget: {
    token: string
    loaderScriptUrl: string
    minPayment: number
    maxPayment: number
  } | null
}

const initialState: InitState = {
  applicationMode: '',
  channelId: '',
  marketCode: '',
  languageCode: '',
  langMarketCode: '',
  assetBaseUrl: '',
  productConfiguratorAdaptersScriptUrl: '',
  productConfiguratorControllerScriptUrl: '',
  isStoreLoggedIn: false,
  content: {},
  partPaymentWidget: null,
}

const initSlice = createSlice({
  name: 'init',
  initialState,
  reducers: {
    handleAppInit(state, action) {
      const {
        applicationMode,
        channelId,
        marketCode,
        languageCode,
        assetBaseUrl,
        productConfiguratorAdaptersScriptUrl,
        productConfiguratorControllerScriptUrl,
        isStoreLoggedIn,
      } = action.payload

      state.applicationMode = applicationMode
      state.channelId = channelId
      state.marketCode = marketCode
      state.languageCode = languageCode
      state.langMarketCode = `${languageCode.substring(0, 2)}-${marketCode}`
      state.assetBaseUrl = assetBaseUrl
      state.productConfiguratorAdaptersScriptUrl = productConfiguratorAdaptersScriptUrl
      state.productConfiguratorControllerScriptUrl = productConfiguratorControllerScriptUrl
      state.isStoreLoggedIn = isStoreLoggedIn
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchContent.fulfilled, (state, action) => {
      state.content = action.payload
    })
    builder.addCase(fetchPartPaymentWidget.fulfilled, (state, action) => {
      const { token, url, minPayment, maxPayment } = action.payload
      state.partPaymentWidget = {
        token,
        loaderScriptUrl: `${url}/walley-checkout-loader.js`,
        minPayment,
        maxPayment,
      }
    })
  },
})

export const { handleAppInit } = initSlice.actions

export default initSlice.reducer
